<template>
  <div class="sign-home">
    <NavBar :navList="NavList" :logoUri="logoUri" routerName="home" title="用户管理"></NavBar>
    <div class="sign-page-content" >
      <router-view class="child"></router-view>
    </div>
    <div class="sign-bottom">
      <BottomBar></BottomBar>
    </div>
  </div>
</template>

<script>
import NavBar from "@/views/navbars/NavBar.vue";
import BottomBar from "@/views/bottombar/BottomBar.vue";
export default {
  data() {
    return {
      NavList: [
        {
          index: "/user/accountBaseInfo",
          title: "账号基本信息"
        },
        {
          index: "/user/mySignature",
          title: "我的签章"
        },
        {
          index: "/user/contacts",
          title: "联系人"
        },
        {
          index: "/user/mySetMeal",
          title: "我的套餐"
        }, {
          index: "/user/myOrder",
          title: "我的订单"
        },
        {
          index: "/user/myAuth",
          title: "我的授权",
          value:''
        },
        {
          index: "/user/feedback",
          title: "问题反馈"
        }
      ],
      logoUri: require("@/assets/img/user-manage.png"),
      height: 500
    };
  },
  created() {
    this.height = this.$store.state.pageViewHeigh;
    if(this.$SIF.getLocalStorage("userInfo").userType == 0){
      this.get_xinx()
    }
  },
  methods:{
    get_xinx(){
      this.$SIF.httpPost({
        url: this.$SIF._serve.auth + "/authorize/queryPage",
        data: {
          entity: {
            authorizeStatus:10
          },
          pageBean: {
            orderBy: '',
            pageNum: 1,
            pageSize: 300
          }
        },
        succFun: res => {

          if(res.data.list.length == 0){
            this.NavList[5].value = 0
          }else {
            this.NavList[5].value = res.data.list.length
          }
        },
        failFun: res =>{

        }
      });
    },
  },
  components: {
    NavBar,
    BottomBar
  }
};
</script>

<style scoped lang="scss">
.sign-home {
  height: 100%;
  background-color: $bg-color;
}
.sign-page-content {
  width: 1180px;
  // background-color: #ffffff;
  margin: 0 auto;
  margin-top: 8px;
  height: -webkit-calc(100% - 196px);
  height: -moz-calc(100% - 196px);
  height: calc(100% - 196px);
  overflow-x: hidden;
  overflow-y: auto;
}
.sign-page-content::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}


.sign-page-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: rgba(0,0,0,0.2);
}

.sign-page-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 0;
  background: rgba(0,0,0,0.1);
}
.sign-bottom {
  width: 100%;
}
</style>

